<script>
export default {
  props: {
    selected: {type: Array},
    selectedDocument: {type: Object},
    isLoading: {type: Boolean}
  },
  computed:  {
    isFirstDocument() {
      return this.$props.selected.indexOf(this.$props.selectedDocument) === 0
    },
    isLastDocument() {
      return Array.isArray(this.$props.selected) && this.$props.selected.indexOf(this.$props.selectedDocument) === this?.$props?.selected?.length - 1
    },
    isDocumentHavingErrors(){
      // eslint-disable-next-line no-prototype-builtins
      return this?.selectedDocument?.hasOwnProperty('errors') && this?.selectedDocument?.errors?.length
    }
  },
  methods: {
    allDocumentsSuccessfullyValidated() {
      // return this.selected.every(item => item.coverSheetStatus === 200) --> legacy check
      return this.selected.every(item => item.coverSheetId !== null)
    },
    checkInputs() {
      if(this?.selected?.length > 1){
        return this.$emit('check')
      }
      return this.$emit('finalize')
    }
  },
}
</script>
<template>
  <v-card-actions class="mx-2">
    <v-row>
      <v-col
        v-if="allDocumentsSuccessfullyValidated()"
        cols="12">
        <v-btn
          color="primary"
          block
          :loading="isLoading"
          @click="$emit('finalize')">
          {{ $t('button.finalize') }}
          <v-icon>mdi-check-all</v-icon>
        </v-btn>
      </v-col>
      <v-col
        v-if="Array.isArray(selected) && selected.length > 1 && !allDocumentsSuccessfullyValidated()"
        cols="6">
        <v-btn
          color="yellow"
          :disabled="isFirstDocument"
          block
          @click="$emit('previous-document')">
          <v-icon>mdi-chevron-left</v-icon>
          {{ $t('button.previous.document') }}
        </v-btn>
      </v-col>
      <v-col
        v-if="isLastDocument && !allDocumentsSuccessfullyValidated()"
        :cols="Array.isArray(selected) && selected.length > 1 ? '6' : '12'">
        <v-btn
          color="yellow"
          block
          :loading="isLoading"
          @click="checkInputs">
          {{ $t('button.check.inputs') }}
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </v-col>
      <v-col
        v-if="Array.isArray(selected) && selected.length > 1 && !isLastDocument && !allDocumentsSuccessfullyValidated()"
        cols="6">
        <v-btn
          v-if="!isDocumentHavingErrors" :disabled="isLastDocument" color="yellow" block
          :loading="isLoading"
          @click="$emit('next-document')">
          {{ $t('button.next.document') }}
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn
          v-if="isDocumentHavingErrors" :disabled="isLastDocument " color="yellow" block
          :loading="isLoading"
          @click="$emit('next-document')">
          {{ $t('button.check.again') }}
          <v-icon>mdi-autorenew</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-card-actions>
</template>
